import React from "react";
import { Link } from "react-router-dom";

const MissionVisionSection = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      heading: "Our Mission & Vision",

      missionTitle: "Our Mission",
      missionDesc:
        "To provide high-calibre, personalised financial solutions that meet the precise needs of every individual and business — with integrity, empathy, and expertise.",

      visionTitle: "Our Vision",
      visionDesc:
        "To be the most trusted financial advisory group in Singapore: a paragon of honesty and excellence for high-net-worth clients and enterprises seeking to optimise their financial future.",

      philosophyTitle: "Our Philosophy",
      philosophyDesc1:
        "Sell with a clear, conscious mind. Every advisor at JT Group is guided by this principle — to place client wellbeing above all else, offering honest counsel that stands the test of time.",
      philosophyDesc2:
        "Every advisor at JT Group follows this principle — placing client wellbeing above all else and offering honest, transparent counsel designed to stand the test of time.",

      rightText:
        "A growing team of 60+ professionals dedicated to excellence",

      btn: "Meet Our Team",
    },

    zh: {
      heading: "我们的使命与愿景",

      missionTitle: "我们的使命",
      missionDesc:
        "以诚信、同理心与专业精神，为个人与企业提供高质量、量身定制的金融解决方案。",

      visionTitle: "我们的愿景",
      visionDesc:
        "成为新加坡最值得信赖的金融咨询团队，为高净值客户与企业提供卓越与诚信的服务。",

      philosophyTitle: "我们的理念",
      philosophyDesc1:
        "以清晰和良知去服务客户。JT Group 的每位顾问都以客户利益为先，提供经得起时间考验的专业建议。",
      philosophyDesc2:
        "我们坚持以客户为中心，提供诚实、透明且长期可靠的财务建议。",

      rightText:
        "拥有 60+ 位专业人士的团队，致力于卓越服务",

      btn: "我们的团队",
    },
  };

  return (
    <section className="bg-[#EBEBEB] py-10">
      <div className="max-w-[1320px] mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-10">
          <h2 className="text-[34px] font-medium text-[#154059]">
            {text[lang].heading}
          </h2>
        </div>


        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* LEFT */}
          <div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">

              {/* Mission */}
              <div className="group bg-white p-6 shadow-sm border border-gray-100
              transition-all duration-300 hover:bg-[#C09F7C]/20">

                <h3 className="text-lg font-bold text-[#C2976C] mb-3
                transition duration-300 group-hover:text-[#154059]">
                  {text[lang].missionTitle}
                </h3>

                <p className="text-gray-600 leading-relaxed text-[15px]">
                  {text[lang].missionDesc}
                </p>

              </div>


              {/* Vision */}
              <div className="group bg-white p-6 shadow-sm border border-gray-100
              transition-all duration-300 hover:bg-[#C09F7C]/20">

                <h3 className="text-lg font-bold text-[#C2976C] mb-3
                transition duration-300 group-hover:text-[#154059]">
                  {text[lang].visionTitle}
                </h3>

                <p className="text-gray-700 leading-relaxed text-[15px]">
                  {text[lang].visionDesc}
                </p>

              </div>

            </div>


            {/* Philosophy */}
            <div className="grid md:grid-cols-1 gap-6 mb-8">

              <div className="group bg-white p-6 shadow-sm border border-gray-100
              transition-all duration-300 hover:bg-[#C09F7C]/20">

                <h3 className="text-lg font-bold text-[#C2976C] mb-3
                transition duration-300 group-hover:text-[#154059]">
                  {text[lang].philosophyTitle}
                </h3>

                <p className="text-gray-600 leading-relaxed text-[15px] mb-2">
                  {text[lang].philosophyDesc1}
                </p>

                <p className="text-gray-600 leading-relaxed text-[15px]">
                  {text[lang].philosophyDesc2}
                </p>

              </div>

            </div>

          </div>


          {/* RIGHT */}
          <div className="relative">

            <div className="bg-[#143c4c] p-8 text-white relative overflow-hidden text-center">

              <h4 className="text-lg font-medium mb-4">
                {text[lang].rightText}
              </h4>

              <div className="relative mt-6">

                <img
                  src="/assets/images/a1.jpeg"
                  alt=""
                  className="w-full object-contain rounded-lg"
                />

                <Link
                  to="/team"
                  className="absolute bottom-1 left-1/2 -translate-x-1/2
                  w-[90%] sm:w-auto text-center
                  bg-[#C2976C] text-white px-6 sm:px-8 py-3
                  font-semibold whitespace-nowrap
                  hover:bg-[#a88257] transition-all duration-300"
                >
                  {text[lang].btn}
                </Link>

              </div>

            </div>

          </div>


        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;